/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
var lozad = require('lozad');
if(!isIE11) {
    const observer = lozad();
    observer.observe();
}

//import Swal from 'sweetalert2'

require('slick-carousel');
require('./front/collapse');
require('./front/jdTab');
require('./front/revealme');
require('./front/parallax');
require('./front/youtubeplayer');
require('./front/main');
require('./front/home');
require('./front/ourCars');
require('./front/recall');
require('./vehicles/overview');
require('./vehicles/car');
require('./vehicles/colors');
require('./vehicles/features');
require('./vehicles/specs');
require('./vehicles/city');
require('./front/buildCarsBuild');
require('./front/shopping');
//require('./front/shopping-current-offers');
require('./front/workshop');
require('./front/GeneralService');
require('./front/servicecenter');
require('./front/OnlineAppointment');
require('./front/KnowYourHonda');
require('./front/preOwned');
require('./front/EstimatePayment');
require('./front/Contact');
require('./front/PartRequest');
window.Gallery = require('./vehicles/gallery');
window.AccessoriesGallery = require('./build-and-prices/AccessoriesGallery');
//window.Vue = require('vue');

import VueCurrencyFilter from 'vue-currency-filter';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('estimate-component', require('./components/EstimateComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
/*
if (VueCurrencyFilter) {
    Vue.use(VueCurrencyFilter, {
        symbol: "$",
        thousandsSeparator: ",",
        fractionCount: 2,
        fractionSeparator: ".",
        symbolPosition: "front",
        symbolSpacing: false
    });
}
 */
/*
const app = new Vue({
    el: '#app'
});*/
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('./front/countid.min');
